import React from "react";
import Table from "./Table";
import emgList from "../data/EMG_LIST.json";
import { EMGRowType } from "../types/NCS_EMG";

type EMGPanelProps = {
  sideOptions: string[];
  rows: EMGRowType[];
  setRows: React.Dispatch<React.SetStateAction<EMGRowType[]>>;
};

const EMGPanel: React.FC<EMGPanelProps> = ({ sideOptions, rows, setRows }) => {
  const headers = [
    "Muscle",
    "Side",
    "IA",
    "Fibs",
    "PSW",
    "Disch",
    "Amp",
    "Dur",
    "Phase",
    "Recrt",
    "IntPat",
  ];

  const groupOptions = Object.keys(emgList);

  const handleAddMuscle = (fullLabel: string) => {
    if (!fullLabel.includes(" - ")) return;
    const [group, muscle] = fullLabel.split(" - ");
    if (!emgList[group]?.includes(muscle)) return;

    const newRows: EMGRowType[] = sideOptions.map((side) => ({
      Muscle: muscle,
      Side: side,
      IA: "",
      Fibs: "",
      PSW: "",
      Disch: "",
      Amp: "",
      Dur: "",
      Phase: "",
      Recrt: "",
      IntPat: "",
    }));

    setRows((prev) => {
      const updated = [...prev];
      let filled = 0;

      for (let index = 0; index < updated.length && filled < newRows.length; index++) {
        const row = updated[index];
        const isEmpty = headers.every((header) => !row[header]);
        if (isEmpty) {
          updated[index] = { ...updated[index], ...newRows[filled++] };
        }
      }

      if (filled < newRows.length) {
        return [...updated, ...newRows.slice(filled)];
      }

      return updated;
    });
  };

  const dropdownOptions: Record<string, string[]> = {
    IA: ["Increased", "Decreased", "Absent"],
    Fibs: ["0", "1+", "2+", "3+", "4+"],
    PSW: ["0", "1+", "2+", "3+", "4+"],
    Disch: ["CRD", "Myotonic", "Myokymic", "Fasciculation"],
    Amp: ["Normal", "Large", "Small", "Giant"],
    Dur: ["Normal", "Long", "Short"],
    Phase: ["Normal", "Polyphasic"],
    Recrt: ["Early", "Decreased"],
    IntPat: ["Normal", "Decreased", "Single Unit", "No MUAP"],
  };

  return (
    <section className="section-block">
      <div className="section-header">
        <h2 className="section-title">EMG</h2>

        <div className="toolbar">
          {groupOptions.map((group) => (
            <select
              key={group}
              className="app-select compact-select"
              onChange={(event) => {
                handleAddMuscle(event.target.value);
                event.target.value = "";
              }}
            >
              <option value="">{`+ Add Muscle (${group})`}</option>
              {emgList[group].map((muscle) => {
                const label = `${group} - ${muscle}`;
                return (
                  <option key={label} value={label}>
                    {label}
                  </option>
                );
              })}
            </select>
          ))}
        </div>
      </div>

      <Table
        title=""
        headers={headers}
        rows={rows}
        setRows={setRows}
        muscleOptions={[]}
        nerveOptions={[]}
        stimOptions={[]}
        recOptions={[]}
        sideOptions={sideOptions}
        isMotor={false}
        dropdownOptions={dropdownOptions}
      />
    </section>
  );
};

export default EMGPanel;
